module.exports = __webpack_public_path__ + "img/大账户.2010f41a.png";